import { IStatus } from "../../../components/StatuLight/StatuLight";
import { IModuleParams } from "../param/paramReducer";

export interface IFixStepAction {
    type: 'FIX_STEP_UPDATE',
    payload?: IFixStep[]
}

export interface IFixStep {
    moduleName: string,
    params: IModuleParams,
    timeStamp: number,
    status: IStatus,
    mid: string,
}

const fixStepDefault: IFixStep[] = [];

function fixStepReducer(state: IFixStep[] = fixStepDefault, action: IFixStepAction): IFixStep[] {

    switch (action.type as string) {
        case "FIX_STEP_UPDATE":
            return action.payload!;
        case "PROGRESS_CLEAR":
            return fixStepDefault;
        default:
            return state;
    }
}
export default fixStepReducer;